import { NgModule } from '@angular/core';

// MATERIAL IMPORTS
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
  ],
  imports: [
    MatDialogModule,
    MatCardModule,
    MatToolbarModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatDividerModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatTooltipModule,
    MatTableModule,
    MatBadgeModule,
    MatGridListModule,
    MatChipsModule,
    MatMenuModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatRippleModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatStepperModule,
    MatRadioModule,
    AngularMyDatePickerModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
  ],
  exports: [
    MatDialogModule,
    MatCardModule,
    MatToolbarModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatDividerModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatTooltipModule,
    MatTableModule,
    MatBadgeModule,
    MatGridListModule,
    MatChipsModule,
    MatMenuModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatRippleModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatStepperModule,
    MatRadioModule,
    AngularMyDatePickerModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [

  ]
})
export class MaterialModule { }
